'use strict';
import React from 'react';
import classnames from 'classnames';
import {find} from 'lodash';
export default class CheckoutPayment extends React.Component {
    selectPayment(payment, e) {
        e.preventDefault();
        this.props.actions.selectPayment(payment);
    }
    render() {
        let cashInAdvance = this.props.cart.getIn(['payment', 'cash_in_advance']).toJS();
        let pickup = this.props.cart.getIn(['payment', 'pickup']).toJS();
        let selectedPayment = this.props.cart.get('selected_payment');

        let paymentInfo = this.props.cart.get('paymentInfo').toJS();
        let cashInAdvanceInfo = find(paymentInfo, {name: 'cash_in_advance'});
        let pickupInfo = find(paymentInfo, {name: 'pickup'});

        return (
            <div className="checkout__payment">
                <div className="payment__title">Versand/Zahlung</div>
                <div className="payment__info">
                    Falls Sie die Ware bei uns abholen, erhalten Sie einen Selbstabholerrabatt von 20,00 € je Artikel.<br />
                    Abholzeiten: Montag bis Samstag von 07:00-20:00 Uhr
                </div>
                <div className={classnames('payment__item', {'payment__item--active': selectedPayment === 'pickup'})}>
                    <a onClick={this.selectPayment.bind(this, 'pickup')} href="#">
                        <span className="item__radio" />{pickupInfo.description} <span className="item__price">{pickup.formatted}</span>
                        <span className="item__info">{pickupInfo.info} </span>
                    </a>
                </div>
                <div className={classnames('payment__item', {'payment__item--active': selectedPayment === 'cash_in_advance'})}>
                    <a onClick={this.selectPayment.bind(this, 'cash_in_advance')} href="#">
                        <span className="item__radio" /> {cashInAdvanceInfo.description} <span className="item__price">{cashInAdvance.formatted}</span>
                    </a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/steps/checkoutPayment.jsx